import Handlebars from 'handlebars';
import {stripHTML} from 'util/StringUtil';


export const getStringRepresentation = (c, templateStr) => {
	if (!c) return '';
	let templateString = stripHTML(getCostTemplateString(templateStr));
	return getConstKeyInfoRepresentation(templateString, 'c')({c});
}

export const getHTMLRepresentation = (c, templateStr) => {
	if (!c) return '';
	let templateString = getCostTemplateString(templateStr)
	return getConstKeyInfoRepresentation(templateString, 'c')({c});
};

function getCostTemplateString(templateStr) {
	return (!templateStr || !templateStr.length) ? '{{kostkey}}' : templateStr;
}

export function wrapTemplateWithSelPanTemplate(templateStr) {
	let templateString = getCostTemplateString(templateStr);

	return '<div class="{{visibleClass}} {{disabledClass}}">' +
		'<div class="SelPanCostCenterEntryLabel">' + templateString + '</div>' +
		'<i data-name="spinner" class="SelPanLiSpinner"></i>' +
		'</div>';
}

export function wrapTemplateWithSelPanLabelViewTemplate(templateStr) {
	let templateString = stripHTML(getCostTemplateString(templateStr));

	return '<span class="SelCostCenterLabelView" title="' + templateString + '">' + templateString + '</span>';
}

export function getConstKeyInfoRepresentation(templateString, context = "") {
	registerHelper('with');

	let mapTemplate = `{{#with ${context}}}${templateString}{{/with}}`
	return Handlebars.compile(mapTemplate);
}

function registerHelper(apiContext) {
	if (apiContext) Handlebars.registerHelper(apiContext, function (context, options) {
		return options.fn(context);
	});

}